
function getMobileOperatingSystem() {
	const userAgent = navigator.userAgent || navigator.vendor || window.opera;

	// Windows Phone must come first because its UA also contains "Android"
	if (/windows phone/i.test(userAgent)) {
		return 'Windows Phone';
	}

	if (/android/i.test(userAgent)) {
		return 'Android';
	}

	//check for chrome os and use same link as Android
	if (/\bCrOS\b/.test(userAgent)) {
		return 'Android'
	}

	// iOS detection from: http://stackoverflow.com/a/9039885/177710
	if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
		return 'iOS';
	}

	return 'unknown';
}

function updateEtreasuryMobile() {
	const switchEleEtreasury = document.getElementsByClassName('href-switch-etreasury');
	const os = getMobileOperatingSystem();

	if (switchEleEtreasury) {
		if (os == 'Android') {
			[].forEach.call(switchEleEtreasury, (elem) => {
				elem.setAttribute('href', 'https://play.google.com/store/apps/details?id=com.obs.android.olm.hudsonvalley.prod&hl=en_US');
			});
		}
	}
}

function updatePersonalMobile() {
	const switchElePersonals = document.getElementsByClassName('href-switch-personal')
	const os = getMobileOperatingSystem();

	if (switchElePersonals) {
		if (os == 'Android') {
			[].forEach.call(switchElePersonals, (elem) => {
				elem.setAttribute('href', 'https://play.google.com/store/apps/details?id=com.sterlingnationalbank.mobile&hl=en');
			});
		}
	}
}

function updateBusinessMobile() {
	const switchEleBusiness = document.getElementsByClassName('href-switch-business');
	const os = getMobileOperatingSystem();

	if (switchEleBusiness) {
		if (os == 'Android') {
			[].forEach.call(switchEleBusiness, (elem) => {
				elem.setAttribute('href', 'https://play.google.com/store/apps/details?id=com.sterling.biz&hl=en');
			});
		}
	}
}

function updateBusinessZelle() {
	const switchEleZelle = document.getElementsByClassName('href-switch-zelle');
	const os = getMobileOperatingSystem();

	if (switchEleZelle) {
		if (os == 'Android') {
			[].forEach.call(switchEleZelle, (elem) => {
				elem.setAttribute('href', 'https://play.google.com/store/apps/details?id=com.sterlingnationalbank.mobile&hl=en');
			});
		}
		if (os == 'iOS') {
			[].forEach.call(switchEleZelle, (elem) => {
				elem.setAttribute('href', 'https://itunes.apple.com/us/app/personal-mobile-banking-for/id940975308?mt=8');
			});
		}
	}
}

function updateCardValet() {
	const switchEleBusiness = document.getElementsByClassName('href-switch-cardvalet');
	const os = getMobileOperatingSystem();

	if (switchEleBusiness) {
		if (os == 'Android') {
			[].forEach.call(switchEleBusiness, (elem) => {
				elem.setAttribute('href', 'https://play.google.com/store/apps/details?id=com.fiservcardvalet.mobile.android');
			});
		}
	}
}

window.addEventListener("load", function(){
	updateEtreasuryMobile();
	updatePersonalMobile();
	updateBusinessMobile();
	updateBusinessZelle();
	updateCardValet();
});

